(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(66558);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ TimeAgo; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 234 modules
var dist = __webpack_require__(68107);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(3716);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(2374);
;// CONCATENATED MODULE: ./components/TimeAgo/TimeAgo.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-style: italic;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-75920c9a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.text.subtle;
});

;// CONCATENATED MODULE: ./components/TimeAgo/TimeAgo.tsx






var TimeAgo = function(param) {
    var dateIsoString = param.dateIsoString, _withIcon = param.withIcon, withIcon = _withIcon === void 0 ? false : _withIcon, _prefix = param.prefix, prefix = _prefix === void 0 ? "" : _prefix;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tooltip */.u, {
            content: (0,date/* formatDateTime */.o0)(dateIsoString, locale),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                gap: "xs",
                alignment: "center",
                children: [
                    withIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                icon: pro_light_svg_icons/* faCalendarAlt */.IV4,
                                size: "m"
                            }),
                            " "
                        ]
                    }),
                    prefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            prefix,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                        children: (0,date/* timeAgo */.Sy)(dateIsoString, locale)
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/TimeAgo/index.ts



/***/ }),

/***/ 66558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page/index.ts + 7 modules
var Page = __webpack_require__(53456);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 234 modules
var dist = __webpack_require__(68107);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/app-pages.ts
var app_pages = __webpack_require__(90729);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(2374);
;// CONCATENATED MODULE: ./features/home/login/HomeLogin.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 3rem;\n\n  div > div > div {\n    padding: 5rem 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LoginContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be3a0fe0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./features/home/login/HomeLogin.tsx







var HomeLogin = function() {
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Card */.Zb, {
            hideImage: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                    as: "h2",
                    size: "3xl",
                    children: t("home:home.welcome_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("home:home.welcome_text")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                    label: t("common.login"),
                    schema: "brand1",
                    variant: "hard",
                    startIcon: pro_solid_svg_icons/* faUserAstronaut */.KCX,
                    href: (0,app_pages/* getPagePath */.mn)(app_pages/* APP_PAGES.login */.EJ.login, locale)
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./features/home/login/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(37328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/layout/HeaderWithActions/index.ts + 2 modules
var HeaderWithActions = __webpack_require__(40026);
// EXTERNAL MODULE: ./components/OfferStatus/index.ts + 2 modules
var OfferStatus = __webpack_require__(93184);
// EXTERNAL MODULE: ./components/shared/HtmlTrans/index.ts + 1 modules
var HtmlTrans = __webpack_require__(75822);
// EXTERNAL MODULE: ./components/TimeAgo/index.ts + 2 modules
var TimeAgo = __webpack_require__(34097);
// EXTERNAL MODULE: ./components/UserGuiding/index.ts + 26 modules
var UserGuiding = __webpack_require__(69410);
// EXTERNAL MODULE: ./hooks/api/useCompany/index.ts + 1 modules
var useCompany = __webpack_require__(22843);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./features/home/offers/HomeOffers.styled.ts

function HomeOffers_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n\n  td a {\n    font-weight: bold;\n    text-decoration: none;\n\n    &:focus,\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  th.home-offers-list-th-status {\n    width: 10%;\n  }\n\n  th.home-offers-list-th-name {\n  }\n\n  th.home-offers-list-th-created-at {\n    width: 15%;\n  }\n\n  th.home-offers-list-th-offer {\n  }\n\n  th.home-offers-list-th-actions {\n    width: 10%;\n  }\n"
    ]);
    HomeOffers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #e0e0e0;\n  margin-top: 3rem;\n\n  tr td {\n    border-bottom: 1px solid #e0e0e0;\n    padding: 1rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 2rem;\n  padding: 4rem 0;\n  background: #eee;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border: 1px solid #cbd5e0;\n  border-radius: 0.25rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: ",
        ";\n    border-color: #a0aec0;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    background-color: #f7fafc;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82b4a086-0"
})(HomeOffers_styled_templateObject());
var HelpTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-82b4a086-1"
})(_templateObject1());
var NoContent = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-82b4a086-2"
})(_templateObject2());
var PaginationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82b4a086-3"
})(_templateObject3());
var PaginationButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-82b4a086-4"
})(_templateObject4(), function(param) {
    var $active = param.$active;
    return $active ? "#2b6cb0" : "#fff";
}, function(param) {
    var $active = param.$active;
    return $active ? "#fff" : "#2d3748";
}, function(param) {
    var $active = param.$active;
    return $active ? "#2b6cb0" : "#edf2f7";
});

;// CONCATENATED MODULE: ./features/home/offers/HomeOffers.tsx

















var HomeOffers = function(param) {
    var offers = param.offers, total = param.total, page = param.page, size = param.size;
    var t = (0,useI18n/* useI18n */.Q)("home").t;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var company = (0,useCompany/* useCompany */.M)().company;
    var ref = (0,react.useState)(false), isOfferStatusHelpModalOpened = ref[0], setIsOfferStatusHelpModalOpened = ref[1];
    var ref1 = (0,react.useState)(false), isOffersListActionsHelpModalOpened = ref1[0], setIsOffersListActionsHelpModalOpened = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserGuiding/* UserGuiding */.J, {
                guide: "offer_list_page"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWithActions/* HeaderWithActions */.c, {
                title: "".concat(t("home.offers.list.title", {
                    company: company === null || company === void 0 ? void 0 : company.name
                }))
            }),
            offers.length <= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                        icon: pro_solid_svg_icons/* faEmptySet */.ImE,
                        size: "4xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("home.offers.list.no-content")
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ControlledTable */.e1, {
                        dataRowId: "id",
                        data: offers,
                        columns: [
                            {
                                type: "badge",
                                label: t("home.offers.list.header.status"),
                                labelSlot: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tooltip */.u, {
                                    content: t("common:common.help"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IconButton */.hU, {
                                        icon: pro_solid_svg_icons/* faCircleQuestion */.FDd,
                                        size: "2xs",
                                        "aria-label": t("common:common.help"),
                                        variant: "bare",
                                        title: t("common:common.help"),
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setIsOfferStatusHelpModalOpened(true);
                                        }
                                    })
                                }),
                                className: "home-offers-list-th-status",
                                sortable: true,
                                sortValue: function(param) {
                                    var status = param.status;
                                    return status;
                                },
                                render: function(param) {
                                    var status = param.status;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                        status: status
                                    });
                                }
                            },
                            {
                                type: "text",
                                label: t("home.offers.list.header.name"),
                                className: "home-offers-list-th-name",
                                sortable: true,
                                sortValue: function(param) {
                                    var name = param.name;
                                    return name;
                                },
                                render: function(param) {
                                    var id = param.id, name = param.name, status = param.status;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: status !== "CANCELLED" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (0,app_pages/* getOfferPagePath */.wo)(id, locale),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: name || t("common:common.no-name-offer")
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tooltip */.u, {
                                            content: t("common:common.process-cancelled"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: name || t("common:common.no-name-offer")
                                            })
                                        })
                                    });
                                }
                            },
                            {
                                type: "text",
                                label: t("home.offers.list.header.createdAt"),
                                className: "home-offers-list-th-created-at",
                                sortable: true,
                                sortValue: function(param) {
                                    var creationDateString = param.creationDateString;
                                    return new Date(creationDateString).getTime();
                                },
                                render: function(param) {
                                    var creationDateString = param.creationDateString;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgo/* TimeAgo */.b, {
                                        dateIsoString: creationDateString
                                    });
                                }
                            }
                        ]
                    }),
                    function() {
                        var totalPages = Math.ceil(total / size);
                        if (totalPages <= 1) return null;
                        var getPageNumbers = function() {
                            var pages = [];
                            var maxVisible = 5;
                            if (totalPages <= maxVisible) {
                                for(var i = 1; i <= totalPages; i++){
                                    pages.push(i);
                                }
                            } else {
                                var start = Math.max(1, page - 2);
                                var end = Math.min(totalPages, page + 2);
                                if (page <= 3) {
                                    end = 5;
                                } else if (page >= totalPages - 2) {
                                    start = totalPages - 4;
                                }
                                for(var i1 = start; i1 <= end; i1++){
                                    pages.push(i1);
                                }
                            }
                            return pages;
                        };
                        var handlePageChange = function(newPage) {
                            router.push({
                                pathname: router.pathname,
                                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                    page: newPage
                                })
                            });
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                                    disabled: page <= 1,
                                    onClick: function() {
                                        return handlePageChange(page - 1);
                                    },
                                    children: t("common:common.pagination.prev", {
                                        defaultValue: "Prev"
                                    })
                                }),
                                getPageNumbers().map(function(p) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                                        $active: p === page,
                                        onClick: function() {
                                            return handlePageChange(p);
                                        },
                                        children: p
                                    }, p);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationButton, {
                                    disabled: page >= totalPages,
                                    onClick: function() {
                                        return handlePageChange(page + 1);
                                    },
                                    children: t("common:common.pagination.next", {
                                        defaultValue: "Next"
                                    })
                                })
                            ]
                        });
                    }()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Modal */.u_, {
                isOpen: isOfferStatusHelpModalOpened,
                onClose: function() {
                    return setIsOfferStatusHelpModalOpened(false);
                },
                title: t("home.offers.list.modal-offer-status-help.title"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* HtmlTrans */.q, {
                        ns: "home",
                        i18nKey: "home.offers.list.modal-offer-status-help.desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelpTable, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "PENDING"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.PENDING")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "SEARCHING_CANDIDATES"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.SEARCHING_CANDIDATES")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "ACTIVE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.ACTIVE")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "PAUSED"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.PAUSED")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "FINISHED"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.FINISHED")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferStatus/* OfferStatus */.P, {
                                            status: "CANCELLED"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("common:common.offer-status-desc.CANCELLED")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Modal */.u_, {
                isOpen: isOffersListActionsHelpModalOpened,
                onClose: function() {
                    return setIsOffersListActionsHelpModalOpened(false);
                },
                title: t("home.offers.list.modal-actions-help.title"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* HtmlTrans */.q, {
                        ns: "home",
                        i18nKey: "home.offers.list.modal-actions-help.desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelpTable, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IconButton */.hU, {
                                            size: "xs",
                                            icon: pro_solid_svg_icons/* faFilePen */._3l,
                                            schema: "neutral",
                                            variant: "ghost",
                                            "aria-label": t("home.offers.list.actions.view-draft-offer"),
                                            title: t("home.offers.list.actions.view-draft-offer")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("home.offers.list.modal-actions-help.view-draft")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IconButton */.hU, {
                                            size: "xs",
                                            icon: pro_solid_svg_icons/* faNewspaper */.Xgz,
                                            schema: "neutral",
                                            variant: "ghost",
                                            "aria-label": t("home.offers.list.actions.view-published-offer"),
                                            title: t("home.offers.list.actions.view-published-offer")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("home.offers.list.modal-actions-help.view-published-offer")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/home/offers/index.ts


;// CONCATENATED MODULE: ./features/home/HomePage.tsx




var HomePage = function(param) {
    var user = param.user, offers = param.offers, total = param.total, page = param.page, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* Page */.T, {
        user: user,
        pageId: "offers",
        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeOffers, {
            offers: offers || [],
            total: total !== null && total !== void 0 ? total : 0,
            page: page !== null && page !== void 0 ? page : 1,
            size: size !== null && size !== void 0 ? size : 10
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLogin, {})
    });
};

;// CONCATENATED MODULE: ./features/home/index.ts


;// CONCATENATED MODULE: ./pages/index.tsx

var __N_SSP = true;
/* harmony default export */ var pages = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [348,20,370,694,308,843,774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);